var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIconBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.0112 8.77073L3.84055 0.401147C2.99079 0.04851 2.03083 0.203637 1.33523 0.805785C0.63962 1.40803  0.348702 2.33591 0.576046 3.22742L2.55818 11.0005L0.576046 18.7735C0.348702 19.665 0.639571 20.5929 1.33518 21.1951C2.0321  21.7986 2.99231 21.9517 3.84055 21.5998L24.0112 13.2302C24.9295 12.8491 25.5 11.9948 25.5 11.0005C25.5 10.0062 24.9295 9.15178  24.0112 8.77073ZM23.4497 11.8772L3.27912 20.2468C2.93991 20.3874 2.5717 20.3281 2.29401 20.0876C2.01638 19.8472 1.90481 19.4913  1.99553 19.1354L3.88317 11.7329H11.1617C11.5663 11.7329 11.8942 11.405 11.8942 11.0004C11.8942 10.5959 11.5663 10.2679 11.1617   10.2679H3.88322L1.99553 2.8655C1.90481 2.50964 2.01638 2.15369 2.29401 1.9133C2.57165 1.67292 2.93977 1.61345 3.27907    1.75417L23.4497 10.1238C23.9929 10.3491 24.0351 10.8518 24.0351 11.0005C24.0351 11.1491 23.9929 11.6518 23.4497 11.8772Z",
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIconBlack);
export default __webpack_public_path__ + "static/media/send-icon-black.d7020b5b0cbba8dda75b398cc1dbb9b5.svg";
export { ForwardRef as ReactComponent };